import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, VStack, Heading, FormControl, FormLabel, Input, Button, useToast } from '@chakra-ui/react';
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from '../firebase';

const AdminLogin = () => {
  const [email, setEmail] =useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      // Use Firebase Auth to sign in
      await signInWithEmailAndPassword(auth, email, password);
      toast({ title: 'Login Successful', status: 'success' });
      navigate('/admin');
    } catch (error) {
      toast({ title: 'Login Failed', description: "Invalid email or password.", status: 'error' });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box p={8} maxWidth="500px" borderWidth={1} borderRadius={8} boxShadow="lg" mx="auto" my={20}>
      <VStack as="form" spacing={4} onSubmit={handleSubmit}>
        <Heading>Admin Login</Heading>
        <FormControl isRequired>
          <FormLabel>Email</FormLabel>
          <Input type="email" placeholder="Enter your admin email" value={email} onChange={(e) => setEmail(e.target.value)} />
        </FormControl>
        <FormControl isRequired>
          <FormLabel>Password</FormLabel>
          <Input type="password" placeholder="Enter your password" value={password} onChange={(e) => setPassword(e.target.value)} />
        </FormControl>
        <Button type="submit" colorScheme="brand" width="full" mt={4} isLoading={isLoading}>
          Log In
        </Button>
      </VStack>
    </Box>
  );
};

export default AdminLogin;